import { createContext, useContext } from 'react';
import { CaptureService } from '../application/capture-service';
export const ServiceContext = createContext<CaptureService | null>(null);
export function useService() { const value = useContext(ServiceContext); if (!value) throw new Error('Database not ready'); return value; }
